import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-text">
        <a href="http://localhost:3000/">
        Profile
        </a>
      </div>
    </footer>
  );
}
